import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { MANUAL_RECOMMENDATIONS_API } from '../../constants/central-api';

interface ManualRecommendationsParams {
  search?: string;
  per_page?: number;
  page?: number;
  status?: string;
  type?: string;
  priority?: string;
  effort?: string;
}

export default async function get_manual_recommendations_api_call(
  params: ManualRecommendationsParams = {}
) {
  const accessToken = store.getState().user?.stats?.ai_tracker_access_token;

  if (!accessToken) {
    return false;
  }

  const queryParams = new URLSearchParams();
  if (params.search) queryParams.append('search', params.search);
  if (params.per_page)
    queryParams.append('per_page', params.per_page.toString());
  if (params.page) queryParams.append('page', params.page.toString());
  if (params.status) queryParams.append('status', params.status);
  if (params.type) queryParams.append('type', params.type);
  if (params.priority) queryParams.append('priority', params.priority);
  if (params.effort) queryParams.append('effort', params.effort);

  const url = queryParams.toString()
    ? `${MANUAL_RECOMMENDATIONS_API}?${queryParams.toString()}`
    : MANUAL_RECOMMENDATIONS_API;

  const requestInfo: RequestInfo = {
    url: url,
    method: 'GET',
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  };

  const actionType = 'GET_MANUAL_RECOMMENDATIONS';
  const customMsg = 'Manual recommendations loaded successfully';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false,
    true,
    false,
    true
  );

  const response = res?.data;
  if (!response?.success) {
    return false;
  }
  if (res?.actionType === actionType && response?.success === true) {
    return response?.data || [];
  }
}
